import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SmartBannersFlowInterface } from '@central-products/interface-smart-banners-flow';
import { injectScript, sleep, appsFlyerScriptContent } from './utils';
import { getDeviceInfo } from '@sitebase/device-detector';
export var SmartBannersFlow = /*#__PURE__*/function (_SmartBannersFlowInte) {
  _inherits(SmartBannersFlow, _SmartBannersFlowInte);

  var _super = _createSuper(SmartBannersFlow);

  function SmartBannersFlow(config) {
    var _this;

    _classCallCheck(this, SmartBannersFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "isAppsFlyerInjected", false);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _this.config = config;
    return _this;
  }

  _createClass(SmartBannersFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var config,
            appsFlyerScript,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.config;

                if (!this.isAppsFlyerInjected) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (getDeviceInfo().isMobile) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return sleep(config.initDelayMs || 0);

              case 7:
                appsFlyerScript = appsFlyerScriptContent(config);
                injectScript(appsFlyerScript, document.getElementsByTagName('head')[0]);

                if (config.autostart) {
                  this.showBanner();
                }

                this.isAppsFlyerInjected = true;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "showBanner",
    value: function showBanner() {
      var _window$AF, _window;

      var _this$config = this.config,
          bannerContainerQuery = _this$config.bannerContainerQuery,
          bannerZIndex = _this$config.bannerZIndex;
      var additionalConfig = {
        bannerZIndex: bannerZIndex || 1000,
        bannerContainerQuery: bannerContainerQuery
      }; // @ts-ignore

      (_window$AF = (_window = window).AF) === null || _window$AF === void 0 ? void 0 : _window$AF.call(_window, 'banners', 'showBanner', additionalConfig);
    }
  }, {
    key: "hideBanner",
    value: function hideBanner() {
      var _window$AF2, _window2;

      // @ts-ignore
      (_window$AF2 = (_window2 = window).AF) === null || _window$AF2 === void 0 ? void 0 : _window$AF2.call(_window2, 'banners', 'hideBanner');
    }
  }]);

  return SmartBannersFlow;
}(SmartBannersFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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